import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import {formatDate} from '@angular/common';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { UnitsService } from 'src/app/services/UnitsService';
import { ClassificationModel } from 'src/app/models/ClassificationModel';
import { ClassificationService } from 'src/app/services/ClassificationService';
import { PharmGroupModel } from 'src/app/models/PharmGroupModel';
import { PharmGroupService } from 'src/app/services/PharmGroupService';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { ItemsService } from 'src/app/services/ItemsService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { ItemssearchComponent } from '../itemssearch/itemssearch.component';
import { ProtocolsearchComponent } from '../protocolsearch/protocolsearch.component';
@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.css'],
})
export class ItemsComponent implements OnInit {
itCode ='' ;
itTName ='' ;
itGName ='' ;
itAName ='' ;
itClass ='' ;
itUnit ='' ;
iTPurchasis = '0' ;
iTMedical = 0 ;
iTMegor ='' ;
iTStore ='' ;
iTGrouping ='' ;
compCode ='1' ;
uaserID ='sa' ;
modifiedDate  = '2021-01-01';

unitsList: UnitsModel[] = [];
classificationList: ClassificationModel[] =[];
pharmGroupList: PharmGroupModel[] =[];


  constructor(public unitsService: UnitsService,
              public units: UnitsModel,
              public items: ItemsModel,
              public itemsSelectedData: ItemsModel,
              public itemsService: ItemsService,
              public classificationService: ClassificationService,
              public classificationModel: ClassificationModel,
              public pharmgroupModel: PharmGroupModel,
              public pharmgroupService: PharmGroupService,
              public storage: LocalStorageService,
              private dialogref: MatDialog,

              )  {}

  ngOnInit(): void {
    this.retriveUnitsLookupTop();
    this.retriveClassificationLookupTop();
    this.retrivePharmGroupLookupTop();
  }

  retriveItems(){
    this.itemsService.getitems(this.itCode,this.compCode).subscribe((data: ItemsModel) => {
      this.itTName = data.itTName;
      this.itGName = data.itGName;
      this.itAName = data.itAName;
      this.itClass = data.itClass;
      this.itUnit = data.itUnit;
      this.iTPurchasis = data.iTPurchasis;
      this.iTMedical = data.iTMedical;
      this.iTMegor = data.iTMegor;

      this.iTStore = data.iTStore;
      this.iTGrouping = data.itGrouping;

      this.compCode = data.compCode;
      this.uaserID = data.uaserID;
      this.modifiedDate = data.modifiedDate;

    })
  }
  NewData() {
    this.itCode ='' ;
    this.itTName ='' ;
    this.itGName ='' ;
    this.itAName ='' ;
    this.itClass ='' ;
    this.itUnit ='' ;
    this.iTPurchasis = '0' ;
    this.iTMedical =0 ;
    this.iTMegor ='' ;
    this.iTStore ='' ;
    this.iTGrouping ='' ;
    this.compCode ='1' ;
    this.uaserID ='sa' ;
    this.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.compCode = '1';
  }

  deleteItems() {
    this.itemsService.delItems(this.itCode, this.storage.retrieve('stgcompCode')).subscribe(
    (data: ItemsModel) => {
      this.itCode = data.itCode;
      this.itTName = data.itTName;
      this.itGName = data.itGName;
      this.itAName = data.itAName;
      this.itClass = data.itClass;
      this.itUnit = data.itUnit;
      this.iTPurchasis = data.iTPurchasis;
      this.iTMedical = data.iTMedical;
      this.iTMegor = data.iTMegor;

      this.iTStore = data.iTStore;
      this.iTGrouping = data.itGrouping;

      this.compCode = data.compCode;
      this.uaserID = data.uaserID;
      this.modifiedDate = data.modifiedDate;
    }
  );
}

  submitItems() {
      this.items.itCode = this.itCode;
      this.items.itTName = this.itTName;
      this.items.itGName = this.itGName;
      this.items.itAName = this.itAName;
      this.items.itClass = this.itClass;
      this.items.itUnit = this.itUnit;
      this.items.iTPurchasis = this.iTPurchasis;
      this.items.iTMedical = this.iTMedical;
      this.items.iTMegor = this.iTMegor;
      this.items.iTStore = this.iTStore;
      this.items.itGrouping = this.iTGrouping;
      this.items.uaserID = this.storage.retrieve('stguserId');
      this.items.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.items.compCode = this.storage.retrieve('stgcompcode')
      this.itemsService.Additems(this.items).subscribe(data => {
      console.log(data.itCode);
      this.mesgSave();
    },
      error => { alert(error); }
    );
  }
  openDialog(){
    const dialogRef = this.dialogref.open(ItemssearchComponent,
      {
        data: {
          dataKey: this.itemsSelectedData
        },
        width:'80%'
    });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
       dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.itCode = result.itCode;
        this.itTName = result.itTName;
        this.itGName = result.itGName;
        this.itAName = result.itAName;
        this.itClass = result.itClass;

        this.itUnit = result.itUnit;
        this.iTPurchasis = result.iTPurchasis;
        this.iTMedical = result.iTMedical;
        this.iTMegor = result.iTMegor;

        this.iTStore = result.iTStore;
        this.iTGrouping = result.itGrouping;
        this.compCode = result.compCode;
        this.uaserID = result.uaserID;
        this.modifiedDate = result.modifiedDate;
        this.retriveItems();
        dialogSubmitSubscription.unsubscribe();
      });
      this.retriveItems();
      }

  ///------------------ Lookups --------------------------
  retriveUnitsLookupTop() {
    this.unitsService
      .getUnitsLookupTop(this.compCode)
      .subscribe((data: UnitsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.unitsList[i] = data[i];
        }
        console.log(data);
      });
  }
  retriveClassificationLookupTop() {
    this.classificationService
      .getClassificationLookupTop(this.compCode)
      .subscribe((data: ClassificationModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.classificationList[i] = data[i];
        }
        console.log(data);
      });
  }
  retrivePharmGroupLookupTop() {
    this.pharmgroupService
      .getPharmGroupLookupTop(this.compCode)
      .subscribe((data: PharmGroupModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.pharmGroupList[i] = data[i];
        }
        console.log(data);
      });
  }

  /////------------------- Delete Message ----------------------------
  mesgDelete() {

    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
        this.deleteItems();
        Swal('Deleted!', 'Your record has been deleted.', 'success');

      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  mesgSave() {
    Swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }

}
